/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/focusableInput.passwordToggle.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'focusableInput/passwordToggle', exports: {} }; const exports = module.exports;

import $ from '@grins/fd-modules/jQuery';

import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

const Selectors = {
    ICON: '.js-fcsbl-pw-toggle-icon',
    TOGGLE: '.js-fcsbl-pw-toggle',
}
const Styles = {
    SHOW_PASSWORD: 'icon-password-show',
    SHOW_PASSWORD_LIGHT: 'icon-password-show--light',
    HIDE_PASSWORD: 'icon-password-hide',
    HIDE_PASSWORD_LIGHT: 'icon-password-hide--light',
}
function onClick(id, opts, e) {
    e.preventDefault();
    const { useLightIcon } = opts || {};
    const $this = $(e.currentTarget);
    const $icon = $(Selectors.ICON);
    const $input = $(`#${id}`);
    const viewClass = useLightIcon ? Styles.SHOW_PASSWORD_LIGHT : Styles.SHOW_PASSWORD;
    const hideClass = useLightIcon ? Styles.HIDE_PASSWORD_LIGHT : Styles.HIDE_PASSWORD;
    const show = $this.data('show') === 'true';
    $input.attr('type', show ? 'password' : 'text');
    $this.data('show', show ? 'false' : 'true');
    $icon.toggleClass(viewClass, !show);
    $icon.toggleClass(hideClass, show);
}
function attach(id, opts) {
    if (!id || typeof id !== 'string' || id[0] === '#') {
        return debugLog.error(module.name, 'attach requires ID string');
    }
    const toggleBtn = document.querySelector(`${Selectors.TOGGLE}[data-for="${id}"]`);
    if (!toggleBtn) {
        return debugLog.error(module.name, 'attach could not locate input');
    }
    toggleBtn.addEventListener('click', onClick.bind(this, id, opts));
}
export default {
    attach,
};